import React from 'react';
import { useNavigate } from 'react-router-dom'
import { useSelector,useDispatch } from 'react-redux';
import {
	CRow,CCol,
	CModal,CModalBody,CModalFooter,CModalHeader,
	CModalTitle, CCloseButton,
	CForm,CFormInput,CFormSelect,CInputGroup,CInputGroupText,CFormCheck,
		CButton,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import { 
	MyDialogform, 
	MyDialoglookup, 
	MyDialoglookupapi, 
} from './index';
import { UFunc } from "../helpers/functions";
import PropTypes from 'prop-types';

const pjson 	= require('../../package.json')
const MyDialogformconsent = props => {	
	const {
		show,toggle,cabangid,pasienid,dokterid,urldone,
		setSessionaktif,prosesExpired,setLoading,showToast,
		...rest
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uPropsobj				= { setSessionaktif,prosesExpired,setLoading,showToast, }
	const uEfekapp					= useSelector(state => state.effectApp);
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uJenisconsentArr			= useSelector(state => state.gJenisconsentArr);

	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uDatacabangArr			= JSON.parse(localStorage.getItem("cabanglist")||"[]")

	const [uDatadokterArr,setDatadokterArr]	= React.useState([]);
	const [uHtml500msg,setHtml500msg]		= React.useState(); 
	const [uNamapasienloaded,setNamapasienloaded]	= React.useState("");
	const [uISPasienloaded,setPasienloaded]	= React.useState(false);

	//--DLGFORM--/
	const [uISDlgformshow,setDlgformshow]			= React.useState(false);
	const [uDlgformdataObj,setDlgformdataObj]		= React.useState({});
	//--END DLGFORM--/

	//--DLGLOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]		= React.useState(false);
	const [uDlglookupdataObj,setDlglookupdataObj]	= React.useState({});
	//--END DLGLOOKUP--/

	//--DLGLOOKUP--/
	const [uISDlglookupapishow,setDlglookupapishow]	= React.useState(false);
	const [uDlglookupapiObj,setDlglookupapiObj]		= React.useState({});
	//--END DLGLOOKUP--/

	//--HANDEL--/
	const hdlKDownPasienlookup = (_EV) => {
		setDlgformdataObj({...uDlgformdataObj,id_pasien:0});

		if(_EV.keyCode !== 13) return;
		const vLookuplabel = (uDlgformdataObj.nama_pasien||"").trim();

		if(vLookuplabel === "") return;

		_EV.preventDefault()
		_EV.stopPropagation();

		setDlglookupapiObj({
			dlg_header: "Lookup: Pasien",
			dlg_input: (uDlgformdataObj.nama_pasien||""),
			url_target: pjson.homepage+"api/api_pasien/ld_lookupapi",
			is_kdowntrigger: true,
		});

		setDlglookupapishow(true);
	}
	const hdlKlikPasienlookup = () => {
		setDlglookupapiObj({
			dlg_header: "Lookup: Pasien",
			dlg_input: (uDlgformdataObj.nama_pasien||""),
			url_target: pjson.homepage+"api/api_pasien/ld_lookupapi",
		});
		setDlglookupapishow(true);
	}
	const hdlKDownDokterlookup = (_EV) => {
		setDlgformdataObj({...uDlgformdataObj,id_dokter:0});

		if(_EV.keyCode !== 13) return;
		const vLookuplabel = (uDlgformdataObj.nama_dokter||"").trim(); 
		if(vLookuplabel === "") return;

		_EV.preventDefault()
		_EV.stopPropagation();

		const vArrCariMaster 	= uDatadokterArr.filter((vItems)=>
			vItems.dokter_caption.toUpperCase().includes(vLookuplabel.toUpperCase()));
		
		if (vArrCariMaster.length === 1) {
			setDlgformdataObj({...uDlgformdataObj,
				nama_dokter: vArrCariMaster[0].dokter_caption||"",
				id_dokter: parseInt(vArrCariMaster[0].id)
			});

			const vElfocus = document.getElementById("btnDialogSimpan");
			vElfocus && vElfocus.focus();
			return;
		}

		hdlKlikDokterlookup();
	}
	const hdlKlikDokterlookup = () => {
		setDlglookupdataObj({
			dlg_header: "Lookup: Nama Dokter",
			dlg_input: (uDlgformdataObj.nama_dokter||""),
			data_arr: uDatadokterArr.map(vItems=>{
				return {
					id: parseInt(vItems.id)||0,
					caption: vItems.dokter_caption,
				}
			}),
		});
		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM 		= parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadokterArr,_IDITEM);
		setDlgformdataObj({...uDlgformdataObj,
			nama_dokter: uDatadokterArr[vArridx].dokter_caption||"",
			id_dokter: parseInt(uDatadokterArr[vArridx].id),
		});

		setDlglookupshow(false);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElfocus = document.getElementById("btnDialogSimpan");
			vElfocus && vElfocus.focus();
		},500);
	}
	const hdlKlikDlglookupapipilih = (_SELECTEDSTR) => {
		_SELECTEDSTR = _SELECTEDSTR||"{}";
		//if(_SELECTEDSTR==="" || _SELECTEDSTR === "{}") return;
		const vLookupObj	= JSON.parse(_SELECTEDSTR);
		if(vLookupObj==={}) return;

		setDlgformdataObj({...uDlgformdataObj,
			nama_pasien: vLookupObj.caption,
			id_pasien: vLookupObj.id || 0,
		})

		setDlglookupapishow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			const vElfocus	= document.getElementById("inpformdokternama");
			vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI--/
		let vElfocus	= document.getElementById("inpformjenisconsentid");
		if((parseInt(uDlgformdataObj.jenis_id)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Jenis Consent Harus Dipilih Terlebih Dahulu !")
			return;
		}
		vElfocus	= document.getElementById("inpformpasiennama");
		if((parseInt(uDlgformdataObj.id_pasien)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("NAMA PASIEN Harus Dipilih Dengan Benar !")
			return;
		}
		vElfocus	= document.getElementById("inpformdokternama");
		if((parseInt(uDlgformdataObj.id_dokter)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("NAMA DOKTER Harus Dipilih Dengan Benar !")
			return;
		}
		//--END VALIDASI--/

		//--EXECUTE_PROCESS--/
		const vNamaform	= "formconsent_"+uDlgformdataObj.jenis_id;
		const vTmpObj	= { ...uDlgformdataObj, 
			dlg_header: undefined,
			url_done: urldone,
		}
		uDispatch({type: "set", gConsentcreateObj: vTmpObj});

		uNavigate("/subpasien/pasien/"+vNamaform+"/0");
		toggle();
		//--END EXECUTE_PROCESS--/
	}
	//--END HANDEL--/

	//--FUNCION--/
	//--END FUNCION--/

	//--CONTENT--/
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		if(uISPasienloaded) return (
			<center><CSpinner color="primary" className="mx-auto my-4"/></center>
		)//>

		return (
		<CForm className="mx-lg-5 px-lg-5">
		<div className="d-none">{JSON.stringify(uDlgformdataObj)}</div>
		<div className="text-center px-lg-5">
			<CFormSelect size="sm"
				value={uDlgformdataObj.jenis_id}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,jenis_id:e.target.value})}
				id="inpformjenisconsentid">
				<option className="text-center">-- PILIH JENIS CONSENT --</option>
				{uJenisconsentArr.map((vItems,vKeys)=>{
					return (
					<option value={vItems.id} key={vKeys}>{vItems.titel_jenis_consent||""}</option>
					)//>
				})}
			</CFormSelect>
		</div>
		<div className="classborderbottom my-3"/>
		
		<CRow className="my-2 mb-3">
		<CCol xs="4">
			<span className="d-none d-md-block">Cabang</span>
			<small className="d-md-none">Cabang</small>
		</CCol>

		<CCol className="text-primary fw-bolder text-uppercase">
			{uDlgformdataObj.nama_cabang}
		</CCol>
		</CRow>

		<CRow className={"my-2"+((parseInt(pasienid)||0) > 0 ? " mb-3" : "")}>
		<CCol xs="4">
			<span className="d-none d-md-block">Nama Pasien</span>
			<small className="d-md-none">Nama Pasien</small>
		</CCol>

		<CCol>
			{(parseInt(pasienid)||0) > 0 ? (
				<b className="text-primary text-uppercase">{uDlgformdataObj.nama_pasien || "Undf Pasien"}</b>
			) : (
			<CInputGroup size="sm">
			<CFormInput size="sm" readOnly={isMobile}
				autoComplete="off"
				placeholder="--Keyword Nama Pasien"
				value={uDlgformdataObj.nama_pasien||""}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,nama_pasien:e.target.value})}
				onKeyDown={(e)=>{if(isMobile) return; hdlKDownPasienlookup(e);}}
				onClick={()=>{if(isMobile) hdlKlikPasienlookup()}}
				id="inpformpasiennama"/>
			<CButton size="sm" onClick={()=>hdlKlikPasienlookup()} color="dark" id="btnformpasienlookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
			)}
		</CCol>
		</CRow>

		<CRow className={"my-2"+((parseInt(dokterid)||0) > 0 ? " mb-3" : "")}>
		<CCol xs="4">
			<span className="d-none d-md-block">Nama Dokter</span>
			<small className="d-md-none">Nama Dokter</small>
		</CCol>
		<CCol>
			{(parseInt(dokterid)||0) > 0 ? (
				<b className="text-primary text-uppercase">{uDlgformdataObj.nama_dokter}</b>
			) : (
			<CInputGroup size="sm">
			<CFormInput size="sm"
				readOnly={uTokenObj.userhak === "DOKTER" || isMobile}
				autoComplete="off"
				placeholder="--Keyword Nama Dokter"
				value={uDlgformdataObj.nama_dokter||""}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,nama_dokter:e.target.value})}
				onKeyDown={(e)=>{if(isMobile) return; hdlKDownDokterlookup(e);}}
				onClick={()=>{if(isMobile && uTokenObj.userhak!=="DOKTER") hdlKlikDokterlookup()}}
				id="inpformdokternama"/>
			{uTokenObj.userhak !== "DOKTER" && (
			<CButton size="sm" onClick={()=>hdlKlikDokterlookup()} color="dark" id="btnformdokterlookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			)}
			</CInputGroup>
			)}
		</CCol>
		</CRow>
		</CForm>
		)//>
	}
	//--END CONTENT--/

	//--API--/
	const apiLoadawal = () => {
		setDatadokterArr([]);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			setEfekview(!uEfekview);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_dokter/ld_dokterlookup";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.tampil) {
				setDatadokterArr(JSON.parse(output_string.datadokter||"[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogformconsent - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			console.log("(MyDialogformconsent - apiLoadawal) catch-error : "+error);
			setHtml500msg("<div class='text-danger'>"+pjson.mydefault.msg500str.join(" ")+"</div>");
		});
	}
	const apiLoadpasien = (_IDPASIEN) => {
		_IDPASIEN	= parseInt(_IDPASIEN)||0;
		setPasienloaded(true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			setEfekview(!uEfekview);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_pasienid: _IDPASIEN,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pasien/ld_detil";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setPasienloaded(false);
			setLoading(false);
			if(output_string.tampil) {
				const vTmpObj = JSON.parse(output_string.datapasien||"{}");
				setNamapasienloaded(vTmpObj.pasien_caption||"Undf Pasien");
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogformconsent - apiLoadpasien) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setPasienloaded(false);
			setLoading(false);
			console.log("(MyDialogformconsent - apiLoadpasien) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	//--STATE--/
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});

		apiLoadawal();

		return () => {
			setDatadokterArr([]);setNamapasienloaded("");
			toggle();
		}
	},[])
	React.useEffect(()=>{
		if(!show) 
			{ toggle(); setPasienloaded(false); return; }

		//--CARI_LABEL_CABANG--/
		const vCabangidx = UFunc.getObjectIndeks(uDatacabangArr,cabangid);
		//--END CARI_LABEL_CABANG--/

		//--CARI_LABEL_DOKTER--/
		const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,dokterid);
		//--END CARI_LABEL_DOKTER--/

		setDlgformdataObj({
			dlg_header: "Buat Consent Baru",
			id_pasien: parseInt(pasienid)||0,
			id_dokter: parseInt(dokterid)||0,
			id_cabang: parseInt(cabangid)||0,
			nama_cabang: (uDatacabangArr[vCabangidx]||{}).cabang_nama,
			nama_dokter: (uDatadokterArr[vDokteridx]||{}).dokter_caption||"",
		});

		if((parseInt(pasienid)||0) > 0) {
			apiLoadpasien(pasienid);
			return;
		}

		setDlgformshow(true);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElButton = document.getElementById("btnDialogSimpan");

			vElButton && (vElButton.innerHTML = "Create Consent");
		},300)
	},[show]);
	React.useEffect(()=>{
		if(!uISDlgformshow)
			{ setDlgformdataObj({}); return }
	},[uISDlgformshow]);
	React.useEffect(()=>{
		if(!uISDlglookupshow)
			{ setDlglookupdataObj(false); return }
	},[uISDlglookupshow]);
	React.useEffect(()=>{
		if(!uISDlglookupapishow)
			{ setDlglookupapiObj(false); return }
	},[uISDlglookupapishow]);
	React.useEffect(()=>{
		if(uNamapasienloaded === "") return;

		setDlgformdataObj({...uDlgformdataObj,
			nama_pasien: uNamapasienloaded,
		});
		setNamapasienloaded("");

		setDlgformshow(true);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElButton = document.getElementById("btnDialogSimpan");

			vElButton && (vElButton.innerHTML = "Create Consent");
		},300)
	},[uNamapasienloaded]);
	//--END STATE--/

	return (
		<>
		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupdataObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupdataObj.dlg_input}
			dataItemArr={uDlglookupdataObj.data_arr||[]} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...uPropsobj}/>

		<MyDialoglookupapi
			show={uISDlglookupapishow}
			toggle={()=>setDlglookupapishow(false)}
			dialogHeader={uDlglookupapiObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupapiObj.dlg_input}
			onKlikPilihItem={hdlKlikDlglookupapipilih}
			targetApi={uDlglookupapiObj.url_target||""}
			kdownTrigger={uDlglookupapiObj.is_kdowntrigger||false}
			id="iddialoglookupapi"
			{...uPropsobj}/>

		<MyDialogform
			options={{size:"lg",centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={show} 
			dialogHeader={uDlgformdataObj.dlg_header}
			toggle={toggle}
			renderContent={contentDlgform()}/>
		</>
	)//>
}

export default MyDialogformconsent;